import { render, staticRenderFns } from "./searchReview.vue?vue&type=template&id=76d81df8"
import script from "./searchReview.vue?vue&type=script&lang=js"
export * from "./searchReview.vue?vue&type=script&lang=js"
import style0 from "./searchReview.vue?vue&type=style&index=0&id=76d81df8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports